import { FlexyFormLabel } from '@europrocurement/flexy-components';
import { Typography } from '@mui/material';
import * as React from 'react';
import AsyncEditableList, { AsyncEditableListProps } from './AsyncEditableList/AsyncEditableList';

type AutocompleteFieldProps = {
    name: string;
    label: string;
    placeholder: string;
} & AsyncEditableListProps;

const AutocompleteField: React.FunctionComponent<AutocompleteFieldProps> = function ({
    name,
    label,
    formContext,
    model,
    placeholder,
    defaultList,
}) {
    return (
        <>
            <FlexyFormLabel>
                <Typography component="span">{label}</Typography>
            </FlexyFormLabel>
            <AsyncEditableList
                inputLabel=""
                formContext={formContext}
                formKey={name}
                defaultList={defaultList}
                formatItem={(item) => (!item ? null : item.id)}
                placeholder={placeholder}
                model={model}
            />
        </>
    );
};

export default AutocompleteField;
